var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheckmarkLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4028 0.5C28.0376 5.33948 34.9348 7.62903 40.8542 7.08777C41.8881 27.9977 34.1661 40.3463 20.4819 45.5C7.26721 40.6763 -0.549201 28.859 0.0305105 6.77063C6.97936 7.13428 13.7967 5.63208 20.4028 0.5ZM12.3722 24.9537C11.9401 24.5839 11.8895 23.9335 12.259 23.501C12.6293 23.0685 13.2797 23.0183 13.7118 23.3878L17.921 27.0042L27.1422 16.866C27.5256 16.4448 28.1779 16.4141 28.5994 16.7971C29.0201 17.1802 29.0509 17.8324 28.6678 18.2539L18.7728 29.1333L18.7721 29.1326C18.3986 29.5431 17.7646 29.5852 17.3402 29.2219L12.3722 24.9537ZM20.4109 3.08362C27.1689 7.36719 33.2744 9.39417 38.5142 8.91479C39.429 27.4235 32.594 38.3545 20.4816 42.916C8.78405 38.6464 1.8645 28.1866 2.37792 8.63391C8.52917 8.95618 14.5636 7.62646 20.4109 3.08362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.9464,
    height: 45,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckmarkLineIcon);
export default __webpack_public_path__ + "static/media/shield-checkmark-line-icon.9504d19ecc83a041847c12a212f16da8.svg";
export { ForwardRef as ReactComponent };